import { ComponentProps, HTMLAttributes } from 'react';
import { TagStyleVariants, TooltipStyles, tagStyles } from './variants';
import { twMerge } from 'tailwind-merge';
import { Typography } from '../typography/typography';
import { match } from 'ts-pattern';
import { Tooltip } from '../../ui';
import { IconInfo, IconInfoCircle } from '@maia/icons';

type TagProps = {
  label: string;
  tooltip?: string;
} & HTMLAttributes<HTMLDivElement> &
  TagStyleVariants;

export function Tag(props: TagProps) {
  const {
    className,
    tooltip,
    variant = 'default',
    size = 'default',
    children,
    label,
    ...rest
  } = props;

  return (
    <span
      className={twMerge(tagStyles({ variant, size }), className)}
      role="status"
      aria-label={label}
      {...rest}
    >
      <Typography
        variant={mapSizeToTypographyVariant(size)}
        weight="medium"
        className="text-nowrap"
      >
        {label}
      </Typography>
      {tooltip && (
        <Tooltip content={tooltip}>
          <IconInfoCircle
            className={TooltipStyles({ variant, className: 'size-16' })}
          />
        </Tooltip>
      )}
    </span>
  );
}

function mapSizeToTypographyVariant(
  size: TagStyleVariants['size'],
): ComponentProps<typeof Typography>['variant'] {
  return match(size)
    .returnType<ComponentProps<typeof Typography>['variant']>()
    .with('default', () => 'body-xs')
    .with('large', () => 'body-s')
    .with('small', () => 'body-xxs')
    .otherwise(() => 'body-xs');
}
